import React__default, { forwardRef, useState, useRef, useEffect, useImperativeHandle } from 'react';
import AppInputStyles from './AppInput.module.scss.js';
import HelperStyles from '../../scss/helper.module.scss.js';
import ValidationError from '../validation-error/ValidationError.js';
import { getHeightByViewPort } from '../../methods/getSizeByViewPort.js';
import classNames from 'classnames';

// export default forwardRef(
//     <T extends string | number | readonly string[] | undefined>(props: AppInputProps<T>, ref: Ref<AppInputRef>) => (
//         <AppInput {...props} ref={ref} />
//     )
// );
const AppInput = forwardRef(({ name, type, isRequired = false, labelText, valuePrefix, valueSuffix, value, onChange, onBlur, onFocus, error, isActiveByDefault = false, labelStyles = {}, containerStyles = {}, inputWrapperStyles = {}, prefixStyles = {}, suffixStyles = {}, inputStyles = {}, isValid = true, placeholder, alwaysShowPrefix, alwaysShowSuffix, setFocus = 0, autoComplete = true, className, containerClassName, labelClassName, inputWrapperClassName, inputClassName, prefixClassName, suffixClassName, activeClassName, dirtyClassName, showValidationErrOnChange = true, disabled = false, errorClass, maxlength, id }, ref) => {
    const [isActive, setIsActive] = useState(false);
    const [isDirty, setIsDirty] = useState(false);
    const inputRef = useRef(null);
    // const numField = useField({ name, type });
    const _onFocus = (e) => {
        onFocus === null || onFocus === void 0 ? void 0 : onFocus(e);
        setIsActive(true);
    };
    const _onBlur = (e) => {
        e.persist();
        setIsDirty(!!e.target.value);
        setIsActive(false);
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
    };
    const _onChange = (e) => {
        e.persist();
        showValidationErrOnChange && setIsDirty(!!e.target.value);
        onChange === null || onChange === void 0 ? void 0 : onChange(e);
    };
    useEffect(() => {
        if (setFocus) {
            setTimeout(() => {
                var _a;
                // elem?.focus();
                (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            }, 1);
        }
    }, [setFocus]);
    const focus = () => {
        setTimeout(() => {
            var _a;
            // elem?.focus();
            (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }, 1);
    };
    useImperativeHandle(ref, () => ({
        focus
    }));
    useEffect(() => {
        // isActiveByDefault &&
        //     setTimeout(() => {
        //         console.log("elem", elem);
        //         elem?.focus();
        //     }, 1);
        if (isActiveByDefault && inputRef.current) {
            inputRef.current.focus();
        }
    }, [isActiveByDefault]);
    return (React__default.createElement("div", { className: classNames(disabled && AppInputStyles.disabled, className) },
        React__default.createElement("div", { 
            // className={classNames(
            //     containerClassName,
            //     HelperStyles.center_vertical +
            //         " " +
            //         AppInputStyles.field_group +
            //         " " +
            //         (isActive ? AppInputStyles.active : "") +
            //         " " +
            //         ((isDirty || value) && !isValid ? AppInputStyles.invalid : ""),
            //     containerClassName
            // )}
            className: classNames(HelperStyles.center_vertical, AppInputStyles.field_group, isActive && AppInputStyles.active, isActive && activeClassName, (isDirty || value) && error && AppInputStyles.invalid, containerClassName), style: containerStyles },
            React__default.createElement("label", { htmlFor: name, 
                // hidden={activeField !== "name" && !isDirty}
                className: classNames(isActive
                    ? AppInputStyles.active + " " + activeClassName
                    : isDirty || value
                        ? AppInputStyles.dirty + " " + dirtyClassName
                        : "", labelClassName), style: labelStyles },
                labelText,
                isRequired && React__default.createElement("span", { className: AppInputStyles.required }, " *")),
            React__default.createElement("div", { style: Object.assign({}, inputWrapperStyles), className: classNames(AppInputStyles.input_wrapper, inputWrapperClassName) },
                React__default.createElement("span", { style: Object.assign({ marginRight: valuePrefix && "9px" }, inputStyles), hidden: !alwaysShowPrefix && !isActive && !(isDirty || value), className: classNames(AppInputStyles.value_prefix, inputClassName, prefixClassName) }, valuePrefix),
                React__default.createElement("input", { 
                    // ref={isActiveByDefault ? refFunc : null}
                    // ref={refFunc}
                    id: id, ref: inputRef, name: name, type: type, onChange: _onChange, onFocus: _onFocus, onBlur: _onBlur, className: classNames(AppInputStyles.input, inputClassName), value: value, style: inputStyles, placeholder: placeholder, autoFocus: isActiveByDefault, autoComplete: !autoComplete ? "off" : undefined, disabled: disabled, maxLength: maxlength, onWheel: (event) => event.currentTarget.blur() }),
                React__default.createElement("span", { style: Object.assign({ marginLeft: valueSuffix && "9px" }, suffixStyles), hidden: !alwaysShowSuffix && !isActive && !(isDirty || value), className: classNames(AppInputStyles.value_suffix, suffixClassName) }, valueSuffix))),
        error && (React__default.createElement(ValidationError, { error: isDirty ? error : "", style: { marginTop: getHeightByViewPort(8) }, errorClass: classNames(errorClass) }))));
});

export { AppInput as default };
//# sourceMappingURL=AppInput.js.map
